import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as NetflixAccountManagementActions from './../actions/netflix-account-management.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  NetflixWebTokenResource,
  TechnicalError,
} from '@dch/products-business-logic';
import { NetflixAccountManagementService } from '../../services/netflix-account-management.service';

@Injectable({
  providedIn: 'root',
})
export class NetflixAccountManagementEffects {
  @Effect()
  getNetflixToken$: Observable<Action> = this.actions$.pipe(
    ofType(NetflixAccountManagementActions.GET_NETFLIX_WEB_TOKEN),
    switchMap((action: NetflixAccountManagementActions.GetNetflixWebToken) =>
      this.netflixAccountManagementService.getNetflixToken().pipe(
        map(
          (entity: IEntity<NetflixWebTokenResource>) =>
            new NetflixAccountManagementActions.GetNetflixWebTokenSuccess(
              entity.value,
            ),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new NetflixAccountManagementActions.GetNetflixWebTokenFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private netflixAccountManagementService: NetflixAccountManagementService,
  ) {}
}
